/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClickerSession } from '../../models/clicker-session';

export interface ClickerSessionsControllerCloseSession$Params {
  id: string;
}

export function clickerSessionsControllerCloseSession(http: HttpClient, rootUrl: string, params: ClickerSessionsControllerCloseSession$Params, context?: HttpContext): Observable<StrictHttpResponse<ClickerSession>> {
  const rb = new RequestBuilder(rootUrl, clickerSessionsControllerCloseSession.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClickerSession>;
    })
  );
}

clickerSessionsControllerCloseSession.PATH = '/clicker/sessions/{id}/close';
